module.exports = __webpack_public_path__ + "img/keyboard_key_6.30973974.png";